import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { LoadingButton } from "@mui/lab";
import {
  Checkbox,
  Divider,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import React, { useEffect, useRef, useState } from "react";
import RemoveShoppingCartOutlinedIcon from "@mui/icons-material/RemoveShoppingCartOutlined";
import DataThresholdingOutlinedIcon from "@mui/icons-material/DataThresholdingOutlined";
import styled from "@emotion/styled";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import DiamondIcon from "@mui/icons-material/Diamond";
import {
  BasketExcelGenerate,
} from "app/shared/ExcelGenerate/ExcelGenerateForSearch";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { DataGrid } from "@mui/x-data-grid";
import { calculateRapDis, calculateRateToDisc } from "app/shared/csvToJson";
import * as Yup from "yup";
import { isMobileDevice } from "app/utils/modifyArrayOfObjectsKeys";
import { getQueryParam } from "app/utils/appHelpers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const validationSchema = Yup.object().shape({
  FL_BANK_CODE: Yup.string().required("Bank is required"),
  // narration: Yup.string().required('Narration is required'),
});
export default function MyBasket() {
  const [basketData, setBasketData] = useState(null);
  const [inventoryType, setInventoryType] = useState("single");
  const [helperdata, setHelperdata] = useState([]);
  const [SelectedStone, setSelectedStone] = useState([]);
  const [SelectedStoneBasketData, setSelectedStoneBasketData] = useState([]);
  const [opetMemoDialoge, setOpetMemoDialoge] = useState(false);
  const [opetSoldDialoge, setOpetSoldDialoge] = useState(false);
  const [userParty, setUserParty] = useState(null);
  const [userSelectedParty, setUserSelectedParty] = useState("");
  const swal = useSwalWrapper();
  const gridRef = useRef(null);
  const jumboco = useJumboAuth();
  const [BLOADER, setBLOADER] = useState(false);
  const isMobile = isMobileDevice();

  useEffect(() => {
    jwtAuthAxios
      .get(
        `master/helper?paramsData=SHIPPEDBY&term=1&curr=1&party=1&tax=VAT_ON_SALES&leadgerdetail=22`
      )
      .then((res) => {
        setHelperdata(res.data?.data);
        setUserParty(res.data?.data?.PARTY || []);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
    // fetchBasketdata();
  }, []);
  const getFieldValue = async (params) => {
    let tmpmdisfield;
    let tmpmdisOBj;
    setTimeout(async () => {
      let cellval = await gridRef.current.getCellValue(params.id, params.field);
      if (Boolean(cellval) && Number(cellval)) {
        switch (params.field) {
          case "MDISC":
            tmpmdisfield = cellval;
            let price = calculateRapDis(params.row.RAP_PRICE, cellval);
            tmpmdisOBj = {
              ...params.row,
              MDISC: cellval,
              MDISCP: price,
              MDISCS: price * params.row.CARATS,
              MDISC2: price * params.row.CARATS * jumboco?.curr?.Rate,
            };
            break;
          case "MDISCP":
            // let discvals =await gridRef.current.getCellValue(params.id, 'MDISC');
            tmpmdisfield = calculateRateToDisc(params.row.RAP_PRICE, cellval);
            tmpmdisOBj = {
              ...params.row,
              MDISC: tmpmdisfield,
              MDISCP: cellval,
              MDISCS: cellval * params.row.CARATS,
              MDISC2: cellval * params.row.CARATS * jumboco?.curr?.Rate,
            };
            // let discval =await gridRef.current.getCellValue(params.id, 'MDISC');
            // tmpmdisfield = calculateRapDis(params.row.RAP_PRICE,discval);
            break;
          case "MDISCS":
            let discvals = cellval / params.row.CARATS;
            tmpmdisfield = calculateRateToDisc(params.row.RAP_PRICE, discvals);
            tmpmdisOBj = {
              ...params.row,
              MDISC: tmpmdisfield,
              MDISCP: discvals,
              MDISCS: cellval,
              MDISC2: cellval * jumboco?.curr?.Rate,
            };
            break;
          case "MDISC2":
            let discvalsamt = cellval / jumboco?.curr?.Rate;
            let discvals2 = cellval / jumboco?.curr?.Rate / params.row.CARATS;
            tmpmdisfield = calculateRateToDisc(params.row.RAP_PRICE, discvals2);
            tmpmdisOBj = {
              ...params.row,
              MDISC: tmpmdisfield,
              MDISCP: discvals2,
              MDISCS: discvalsamt,
              MDISC2: cellval,
            };
            break;
          default:
            tmpmdisfield = 0;
            break;
        }
        let upObj = basketData.map((sdata) => {
          if (sdata.STONE == params.id) {
            return tmpmdisOBj;
          } else {
            return sdata;
          }
        });
        setBasketData(upObj);
      }
    }, 100);
  };

  useEffect(() => {
    let data = basketData?.filter((d) => SelectedStone?.includes(d.STONE));
    setSelectedStoneBasketData(data || []);
  }, [SelectedStone]);
  const fetchBasketdata = () => {
    setBasketData(null);
    setSelectedStone([]);
    {
      userSelectedParty &&
        jwtAuthAxios
          .get(`user/basket/${userSelectedParty}?type=${inventoryType}`)
          .then((res) => {
            setBasketData(res.data.data);
          })
          .catch((e) => {
            swal.fire({
              icon: "error",
              text: "Internal server Error",
            });
          });
    }
  };
  useEffect(() => {
    fetchBasketdata();
  }, [inventoryType]);

  useEffect(() => {
    fetchBasketdata();
  }, [userSelectedParty]);
  const ReomvetoBasketHandler = () => {
    setBLOADER(true);
    jwtAuthAxios
      .post(`user/basket/delete`, {
        stone_id: SelectedStone,
        Party: userSelectedParty,
        type: inventoryType == "jewel" ? "jewel" : "single",
      })
      .then((res) => {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        fetchBasketdata();
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      })
      .finally(() => setBLOADER(false));
  };
  const ShippingFormMemoDialog = ({
    SelectedStone,
    userSelectedParty,
    basketData,
    open,
    handleClose,
  }) => {

    const [ButtonLoadng, setButtonLoadng] = useState(false);
    const swal = useSwalWrapper();
    const handleSubmit = async (values, { resetForm }) => {
      // Handle form submission logic here
      let SelectedDatafilter = basketData?.filter((sdata) =>
        SelectedStone.includes(
          inventoryType == "jewel" ? sdata?.FL_ITEM_CODE : sdata.STONE
        )
      );

      let SelectedData = SelectedDatafilter.map((s) => ({
        ...s,
        MDISC2:
          s?.MDISC2 ||
          values.FL_CONV_RATE *
          (((s.RAP_PRICE * (100 - s.MDISC)) / 100) * s.CARATS),
      }));

      // resetForm();
      if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
        setButtonLoadng(true);
        await jwtAuthAxios
          .post(
            `transation/${inventoryType == "single"
              ? "polishOutward"
              : inventoryType == "jewel"
                ? "jewel/polishOutward"
                : "bulk/polishOutward"
            }`,
            {
              ...values,
              Party: userSelectedParty,
              transactionType: 33,
              StoneData: SelectedData,
              isDetail: "Y",
            }
          )
          .then((res) => {
            swal.fire({
              icon: "success",
              text: res.data.message,
            });
            resetForm();
            handleClose();
            fetchBasketdata();
          })
          .catch((e) => {
            swal.fire({
              icon: "error",
              text: "Internal server Error",
            });
          })
          .finally(() => {
            setButtonLoadng(false);
          });
      } else {
        swal.fire({
          icon: "error",
          text: "Please Fill Detail",
        });
      }
    };
    const jumboco = useJumboAuth();
    const initialValues = {
      shippingNumber: "",
      FL_CURR_CODE: "2",
      FL_CONV_RATE: jumboco?.curr?.Rate,
      term: "",
      shipBy: "37",
      narration: "",
    };

    return (
      <Dialog open={open} maxWidth={"lg"} onClose={handleClose}>
        <DialogTitle>Shipping Information</DialogTitle>
        <DialogContent>
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ handleSubmit, setFieldValue }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item lg={6}>
                    <Field
                      name="FL_CURR_CODE"
                      size="small"
                      a
                      as={TextField}
                      style={{ margin: "7px 0" }}
                      select
                      label="Currency Type"
                      fullWidth
                    >
                      {helperdata?.CURR?.map((option) => (
                        <MenuItem
                          key={option.FL_CURRENCY_ID}
                          value={option.FL_CURRENCY_ID}
                        >
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="FL_CONV_RATE"
                      size="small"
                      as={TextField}
                      style={{ margin: "7px 0" }}
                      type="number"
                      label="Conv Rate"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Field
                  name="term"
                  size="small"
                  as={TextField}
                  style={{ margin: "7px 0" }}
                  select
                  label="Memo Term"
                  fullWidth
                >
                  {helperdata?.TERM?.map((option) => (
                    <MenuItem
                      key={option.FL_TERM_CODE}
                      color="primary"
                      value={option.FL_TERM_CODE}
                    >
                      {option.FL_TERM_NAME}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="shippingNumber"
                  size="small"
                  as={TextField}
                  style={{ margin: "7px 0" }}
                  label="Tracking Number"
                  fullWidth
                />
                <Field
                  name="shipBy"
                  size="small"
                  as={TextField}
                  style={{ margin: "7px 0" }}
                  select
                  label="Ship By"
                  fullWidth
                >
                  {helperdata?.SHIPPEDBY?.map((option) => (
                    <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                      {option.FL_PARA_VALUE}
                    </MenuItem>
                  ))}
                </Field>
                <InputLabel>Naration</InputLabel>
                <Field
                  size="small"
                  component={TextareaAutosize}
                  name="narration"
                  label="Naration"
                  minRows={3}
                  onChange={(e) => setFieldValue("narration", e.target.value)}
                  style={{ width: "100%" }}
                  fullWidth
                />
                <LoadingButton
                  loading={ButtonLoadng}
                  variant="contained"
                  color="primary"
                  sx={{
                    display: "block",
                    marginLeft: "auto",
                    mt: 3,
                  }}
                  type="submit"
                >
                  Memo
                </LoadingButton>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  };
  const ShippingFormSoldDialog = ({
    SelectedStone,
    userSelectedParty,
    open,
    handleClose,
  }) => {
    const [ButtonLoadng, setButtonLoadng] = useState(false);
    const [stoneDataDetailData, setStoneDataDetailData] = useState([]);
    const [stoneDataDetail, setStoneDataDetail] = useState(null);
    const [CurrencyName, setCurrencyName] = useState(null);
    const swal = useSwalWrapper();
    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    }));
    useEffect(() => {
      let sdataD = basketData?.filter((sdata) =>
        SelectedStone.includes(sdata.STONE)
      );
      setStoneDataDetailData(sdataD);
    }, [SelectedStone]);
    useEffect(() => {
      let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0, amt2: 0, amt1: 0 };
      stoneDataDetailData?.forEach((sdata) => {
        tempCal = {
          pcs: tempCal.pcs + 1,
          cts: tempCal.cts + sdata.CARATS,
          rap: Number(tempCal.rap) + Number(sdata.RAP_PRICE),
          disc: Number(tempCal.disc) + Number(sdata.MDISC),
          amt1:
            Number(tempCal.amt1) +
            Number(
              sdata.MDISCS ||
              ((sdata.RAP_PRICE * (100 - sdata.MDISC)) / 100) * sdata.CARATS
            ),
        };
      });
      tempCal = {
        pcs: tempCal.pcs,
        amt1: tempCal.amt1,
        cts: tempCal.cts,
        rap: Number(tempCal.rap) / Number(tempCal.pcs),
        disc: Number(tempCal.disc) / Number(tempCal.pcs),
      };
      // alert(tempCal.amt1+'-'+tempCal.cts)
      tempCal = {
        ...tempCal,
        price: tempCal.amt1 / tempCal.cts, //Number(tempCal.rap) - (tempCal.rap * tempCal.disc / 100)
      };
      tempCal.pcs != 0 && setStoneDataDetail({ ...tempCal, amt: tempCal.amt1 });

    }, [basketData, stoneDataDetailData]);
    const handleSubmit = async (values, { resetForm }) => {
      // Handle form submission logic here
      if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
        // let SelectedData = basketData.filter((sdata => SelectedStone.includes(sdata.STONE)))
        setButtonLoadng(true);
        let SelectedData = stoneDataDetailData.map((s) => ({
          ...s,
          MDISC2:
            s?.MDISC2 ||
            values.FL_CONV_RATE *
            (((s.RAP_PRICE * (100 - s.MDISC)) / 100) * s.CARATS),
        }));
        // resetForm();
        await jwtAuthAxios
          .post(`transation/polishOutward`, {
            ...values,
            Party: userSelectedParty,
            transactionType: 35,
            StoneData: SelectedData,
            isDetail: "Y",
          })
          .then((res) => {
            swal.fire({
              icon: "success",
              text: res.data.message,
            });
            resetForm();
            handleClose();
            fetchBasketdata();
          })
          .catch((e) => {
            swal.fire({
              icon: "error",
              text: "Internal server Error",
            });
          })
          .finally(() => {
            setButtonLoadng(false);
          });
      } else {
        swal.fire({
          icon: "error",
          text: "Please Fill Detail",
        });
      }
    };
    const jumboco = useJumboAuth();
    const [initialValues, setInitialValues] = useState({
      shippingNumber: "",
      FL_BANK_CODE: "",
      term: "",
      shipBy: "",
      ShipingCharge: 0,
      CertCharge: 0,
      narration: "",
      OtherCharge: 0,
      is_p: false,
      Discount: 0,
      wat_per: helperdata?.TAX?.FL_TAX_PER,
      FL_CURR_CODE: "2",
      FL_CURR_CODE: "2",
      FL_CONV_RATE: jumboco?.curr?.Rate,
    });
    useEffect(() => {
      setInitialValues({
        ...initialValues,
        wat_per: helperdata?.TAX?.FL_TAX_PER,
      });
    }, [helperdata]);


    
    const [userDetails, setUserDetails] = useState(null);

    const isAdmin = Number(userDetails?.FL_ROLE_ID) === 1;
    useEffect(() => {
      try {
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
          setUserDetails(JSON.parse(storedUser));
        }
      } catch (error) {
        console.error("Failed to parse user from localStorage:", error);
        localStorage.removeItem("user");
      }
    }, []);

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Sold Shipping Information</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, values, setFieldValue, errors, touched }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel>Select Bank</InputLabel>
                    <Field
                      size="small"
                      name="FL_BANK_CODE"
                      InputLabel="Select Bank"
                      as={Select}
                      fullWidth
                    >
                      <MenuItem value="">Select Select Bank</MenuItem>
                      {helperdata?.leadgerdetail?.map((item) => (
                        <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                      ))}
                    </Field>
                    {errors.FL_BANK_CODE && touched.FL_BANK_CODE && (
                      <div className="error">{errors.FL_BANK_CODE}</div>
                    )}
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <Field
                      name="FL_CURR_CODE"
                      as={TextField}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      select
                      label="Currency Type"
                      fullWidth
                    >
                      {helperdata?.CURR?.map((option) => (
                        <MenuItem
                          key={option.FL_CURRENCY_ID}
                          onClick={(e) => {
                            setCurrencyName(option.FL_CURRENCY_NAME);
                          }}
                          value={option.FL_CURRENCY_ID}
                        >
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <Field
                      name="FL_CONV_RATE"
                      as={TextField}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      type="number"
                      label="Conv Rate"
                      fullWidth
                    />
                  </Grid>
                </Grid>

                <Field
                  name="term"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Payment Term"
                  fullWidth
                >
                  {helperdata?.TERM?.map((option) => (
                    <MenuItem
                      key={option.FL_TERM_CODE}
                      color="primary"
                      value={option.FL_TERM_CODE}
                    >
                      {option.FL_TERM_NAME}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="shippingNumber"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Shipping Number"
                  fullWidth
                />
                <Field
                  name="shipBy"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Ship By"
                  fullWidth
                >
                  {helperdata?.SHIPPEDBY?.map((option) => (
                    <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                      {option.FL_PARA_VALUE}
                    </MenuItem>
                  ))}
                </Field>
                <Grid container columnSpacing={2}>
                  <Grid item lg={6} xs={12}>
                    <Field
                      name="wat_per"
                      disabled={values.is_p != true}
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={helperdata?.TAX?.FL_TAX_PER || 0}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="vat Charge(%)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <Field
                      name="ShipingCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="Shiping Charge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <Field
                      name="CertCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="Cert. Charge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <Field
                      name="OtherCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="OtherCharge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6} xs={12}></Grid>
                </Grid>
                <Field
                  name="Discount"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Discount(-AMT)"
                  fullWidth
                />
                 {isAdmin && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Transaction Date"
                      format="MM-DD-YYYY"
                      value={
                        values.FL_TRANS_DATE
                          ? dayjs(values.FL_TRANS_DATE)
                          : null
                      }
                      minDate={
                        helperdata?.finyears?.length
                          ? dayjs(
                            `${helperdata.finyears[0]?.FL_FIN_YEAR?.split("-")[0]}-01-01`,
                          )
                          : undefined
                      }
                      maxDate={dayjs()}
                      onChange={(date, context) => {
                        if (!date || !date.isValid()) {
                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        const today = dayjs();

                        // Future date validation
                        if (date.isAfter(today, "day")) {
                          alert(
                            `Transaction date cannot be greater than ${today.format("MM-DD-YYYY")}.`,
                          );

                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        // Your existing minDate validation
                        const minDate = helperdata?.finyears?.length
                          ? dayjs(
                            `${helperdata.finyears[0]?.FL_FIN_YEAR?.split("-")[0]}-01-01`,
                          )
                          : null;

                        if (minDate && date.isBefore(minDate, "day")) {
                          alert(
                            `Transaction date cannot be before ${minDate.format("MM-DD-YYYY")}.`,
                          );

                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        setFieldValue(
                          "FL_TRANS_DATE",
                          date.format("YYYY-MM-DD"),
                        );
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          style: { margin: "7px 0" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
                <InputLabel>Naration</InputLabel>
                <Field
                  size="small"
                  component={TextareaAutosize}
                  name="narration"
                  label="Naration"
                  minRows={3}
                  style={{ width: "100%" }}
                  fullWidth
                />
                <Field
                  name="is_p"
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          onClick={() =>
                            !values.is_p
                              ? setFieldValue("wat_per", 0)
                              : setFieldValue(
                                "wat_per",
                                helperdata?.TAX?.FL_TAX_PER
                              )
                          }
                          style={{ margin: "5px 0" }}
                          size="small"
                        // checked={field.value}
                        // Add any other Checkbox props here
                        />
                      }
                      label="IS P"
                      fullWidth
                    />
                  )}
                />
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1, mt: 3 }}
                >
                  <Item>Pcs {stoneDataDetail?.pcs || 0}</Item>
                  <Item>CTS {stoneDataDetail?.cts?.toFixed(2) || 0.0}</Item>
                  <Item>Rap {stoneDataDetail?.rap.toFixed(2) || 0}</Item>
                  <Item>Disc% {stoneDataDetail?.disc?.toFixed(2) || 0}</Item>
                  <Item>vat% {values.wat_per || 0}</Item>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1 }}
                >
                  <Item>
                    ShipingCharge ($AMT) = {values.ShipingCharge || 0}
                  </Item>
                  <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                  <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                  <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1 }}
                >
                  <Item>
                    Price/cts($) ={" "}
                    {(
                      stoneDataDetail?.price +
                      (stoneDataDetail?.price * (values.wat_per || 0)) / 100
                    )?.toFixed(2) || 0}
                  </Item>

                  <Item>
                    Total Amt ($) ={" "}
                    {(
                      Number(stoneDataDetail?.price || 0) *
                      Number(stoneDataDetail?.cts || 0) +
                      (Number(stoneDataDetail?.price || 0) *
                        Number(stoneDataDetail?.cts || 0) *
                        (values.wat_per || 0)) /
                      100 +
                      (values.CertCharge || 0) +
                      (values.OtherCharge || 0) +
                      (values.ShipingCharge || 0) -
                      (values.Discount || 0)
                    ).toFixed(2)}
                  </Item>
                  <Item>
                    Total Amt ({CurrencyName || "RMB"}) ={" "}
                    {(
                      (Number(stoneDataDetail?.price || 0) *
                        Number(stoneDataDetail?.cts || 0) +
                        (Number(stoneDataDetail?.price || 0) *
                          Number(stoneDataDetail?.cts || 0) *
                          (values.wat_per || 0)) /
                        100 +
                        (values.CertCharge || 0) +
                        (values.OtherCharge || 0) +
                        (values.ShipingCharge || 0) -
                        (values.Discount || 0)) *
                      values.FL_CONV_RATE
                    ).toFixed(2)}
                  </Item>
                </Stack>
                <LoadingButton
                  loading={ButtonLoadng}
                  variant="contained"
                  color="primary"
                  sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                  type="submit"
                >
                  Sold
                </LoadingButton>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  };
  const BulkShippingFormSoldDialog = ({
    SelectedStone,
    userSelectedParty,
    open,
    handleClose,
  }) => {
    const [ButtonLoadng, setButtonLoadng] = useState(false);
    const [stoneDataDetailData, setStoneDataDetailData] = useState([]);
    const [stoneDataDetail, setStoneDataDetail] = useState(null);
    const [CurrencyName, setCurrencyName] = useState(null);
    const swal = useSwalWrapper();
    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    }));
    useEffect(() => {
      let sdataD = basketData?.filter((sdata) =>
        SelectedStone.includes(sdata.STONE)
      );

      setStoneDataDetailData(sdataD);
    }, [SelectedStone]);

    useEffect(() => {

      let TMPOBJ = {
        pcs: stoneDataDetailData.length,
        cts: stoneDataDetailData.reduce(
          (acc, obj) => acc + obj.FL_SELL_CARATS,
          0
        ),
        TotalAMT: stoneDataDetailData.reduce(
          (acc, obj) => acc + obj.FL_RATE2,
          0
        ),
        price:
          stoneDataDetailData.reduce((acc, obj) => acc + obj.FL_RATE, 0) /
          stoneDataDetailData.length,
      };
      setStoneDataDetail({
        ...TMPOBJ,
        amt: TMPOBJ.TotalAMT / jumboco?.curr?.Rate,
      });
    }, [basketData, stoneDataDetailData]);
    const handleSubmit = async (values, { resetForm }) => {
      // Handle form submission logic here
      if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
        // let SelectedData = basketData.filter((sdata => SelectedStone.includes(sdata.STONE)))
        setButtonLoadng(true);
        // resetForm();
        await jwtAuthAxios
          .post(`transation/bulk/polishOutward`, {
            ...values,
            Party: userSelectedParty,
            transactionType: 35,
            StoneData: stoneDataDetailData,
            isDetail: "Y",
          })
          .then((res) => {
            swal.fire({
              icon: "success",
              text: res.data.message,
            });
            resetForm();
            handleClose();
            fetchBasketdata();
          })
          .catch((e) => {
            swal.fire({
              icon: "error",
              text: "Internal server Error",
            });
          })
          .finally(() => {
            setButtonLoadng(false);
          });
      } else {
        swal.fire({
          icon: "error",
          text: "Please Fill Detail",
        });
      }
    };
    const jumboco = useJumboAuth();

    const [initialValues, setInitialValues] = useState({
      shippingNumber: "",
      FL_BANK_CODE: "",
      term: "",
      shipBy: "",
      ShipingCharge: 0,
      CertCharge: 0,
      narration: "",
      OtherCharge: 0,
      is_p: false,
      Discount: 0,
      wat_per: helperdata?.TAX?.FL_TAX_PER,
      FL_CURR_CODE: "2",
      FL_CONV_RATE: jumboco?.curr?.Rate,
    });
    useEffect(() => {
      setInitialValues({
        ...initialValues,
        wat_per: helperdata?.TAX?.FL_TAX_PER,
      });
    }, [helperdata]);
      
    const [userDetails, setUserDetails] = useState(null);

    const isAdmin = Number(userDetails?.FL_ROLE_ID) === 1;
    useEffect(() => {
      try {
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
          setUserDetails(JSON.parse(storedUser));
        }
      } catch (error) {
        console.error("Failed to parse user from localStorage:", error);
        localStorage.removeItem("user");
      }
    }, []);

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Sold Shipping Information</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, values, setFieldValue, errors, touched }) => (
              <Form onSubmit={handleSubmit}>
                <Grid item xs={12}>
                  <InputLabel>Select Bank</InputLabel>
                  <Field
                    size="small"
                    name="FL_BANK_CODE"
                    InputLabel="Select Bank"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Bank</MenuItem>
                    {helperdata?.leadgerdetail?.map((item) => (
                      <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                    ))}
                  </Field>
                  {errors.FL_BANK_CODE && touched.FL_BANK_CODE && (
                    <div className="error">{errors.FL_BANK_CODE}</div>
                  )}
                </Grid>
                <Grid container spacing={2}>
                  <Grid item lg={6}>
                    <Field
                      name="FL_CURR_CODE"
                      as={TextField}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      select
                      label="Currency Type"
                      fullWidth
                    >
                      {helperdata?.CURR?.map((option) => (
                        <MenuItem
                          key={option.FL_CURRENCY_ID}
                          onClick={(e) => {
                            setCurrencyName(option.FL_CURRENCY_NAME);
                          }}
                          value={option.FL_CURRENCY_ID}
                        >
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="FL_CONV_RATE"
                      as={TextField}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      type="number"
                      label="Conv Rate"
                      fullWidth
                    />
                  </Grid>
                </Grid>

                <Field
                  name="term"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Payment Term"
                  fullWidth
                >
                  {helperdata?.TERM?.map((option) => (
                    <MenuItem
                      key={option.FL_TERM_CODE}
                      color="primary"
                      value={option.FL_TERM_CODE}
                    >
                      {option.FL_TERM_NAME}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="shippingNumber"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Shipping Number"
                  fullWidth
                />
                <Field
                  name="shipBy"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Ship By"
                  fullWidth
                >
                  {helperdata?.SHIPPEDBY?.map((option) => (
                    <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                      {option.FL_PARA_VALUE}
                    </MenuItem>
                  ))}
                </Field>
                <Grid container columnSpacing={2}>
                  <Grid item lg={6}>
                    <Field
                      name="wat_per"
                      disabled={values.is_p != true}
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="vat Charge(%)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="ShipingCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="Shiping Charge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="CertCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="Cert. Charge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="OtherCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="OtherCharge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}></Grid>
                </Grid>
                <Field
                  name="Discount"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Discount(-AMT)"
                  fullWidth
                />
                 {isAdmin && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Transaction Date"
                      format="MM-DD-YYYY"
                      value={
                        values.FL_TRANS_DATE
                          ? dayjs(values.FL_TRANS_DATE)
                          : null
                      }
                      minDate={
                        helperdata?.finyears?.length
                          ? dayjs(
                            `${helperdata.finyears[0]?.FL_FIN_YEAR?.split("-")[0]}-01-01`,
                          )
                          : undefined
                      }
                      maxDate={dayjs()}
                      onChange={(date, context) => {
                        if (!date || !date.isValid()) {
                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        const today = dayjs();

                        // Future date validation
                        if (date.isAfter(today, "day")) {
                          alert(
                            `Transaction date cannot be greater than ${today.format("MM-DD-YYYY")}.`,
                          );

                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        // Your existing minDate validation
                        const minDate = helperdata?.finyears?.length
                          ? dayjs(
                            `${helperdata.finyears[0]?.FL_FIN_YEAR?.split("-")[0]}-01-01`,
                          )
                          : null;

                        if (minDate && date.isBefore(minDate, "day")) {
                          alert(
                            `Transaction date cannot be before ${minDate.format("MM-DD-YYYY")}.`,
                          );

                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        setFieldValue(
                          "FL_TRANS_DATE",
                          date.format("YYYY-MM-DD"),
                        );
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          style: { margin: "7px 0" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
                <InputLabel>Naration</InputLabel>
                <Field
                  size="small"
                  component={TextareaAutosize}
                  name="narration"
                  label="Naration"
                  minRows={3}
                  onChange={(e) => setFieldValue("narration", e.target.value)}
                  style={{ width: "100%" }}
                  fullWidth
                />
                <Field
                  name="is_p"
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          onClick={() =>
                            !values.is_p
                              ? setFieldValue("wat_per", 0)
                              : setFieldValue(
                                "wat_per",
                                helperdata?.TAX?.FL_TAX_PER
                              )
                          }
                          style={{ margin: "5px 0" }}
                          size="small"
                        // checked={field.value}
                        // Add any other Checkbox props here
                        />
                      }
                      label="IS P"
                      fullWidth
                    />
                  )}
                />
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1, mt: 3 }}
                >
                  <Item>Lot: {stoneDataDetail?.pcs || 0}</Item>
                  <Item>CTS {stoneDataDetail?.cts?.toFixed(2) || 0.0}</Item>
                  {/* <Item>Price  {stoneDataDetail?.price.toFixed(2) || 0}</Item>
                  <Item>Amount  {stoneDataDetail?.amt?.toFixed(2) || 0}</Item> */}
                  <Item>vat% {values.wat_per || 0}</Item>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1 }}
                >
                  <Item>
                    ShipingCharge ($AMT) = {values.ShipingCharge || 0}
                  </Item>
                  <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                  <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                  <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1 }}
                >
                  <Item>
                    Price/cts($) ={" "}
                    {(
                      stoneDataDetail?.price +
                      (stoneDataDetail?.price * (values.wat_per || 0)) / 100
                    )?.toFixed(2) || 0}
                  </Item>
                  {/* <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge -values.Discount) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item>
                    <Item>Total Amt ({CurrencyName || 'RMB'}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item> */}
                  <Item>
                    Total Amt ($) ={" "}
                    {(
                      Number(stoneDataDetail?.amt || 0) +
                      ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                      100 +
                      (values.CertCharge || 0) +
                      (values.OtherCharge || 0) +
                      (values.ShipingCharge || 0) -
                      (values.Discount || 0)
                    ).toFixed(2)}
                  </Item>
                  <Item>
                    Total Amt ({CurrencyName || "RMB"}) ={" "}
                    {(
                      (Number(stoneDataDetail?.amt || 0) +
                        ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                        100 +
                        (values.CertCharge || 0) +
                        (values.OtherCharge || 0) +
                        (values.ShipingCharge || 0) -
                        (values.Discount || 0)) *
                      values.FL_CONV_RATE
                    ).toFixed(2)}
                  </Item>
                </Stack>
                <LoadingButton
                  loading={ButtonLoadng}
                  variant="contained"
                  color="primary"
                  sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                  type="submit"
                >
                  Sold
                </LoadingButton>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  };

  const JewelryShippingFormSoldDialog = ({
    SelectedStone,
    userSelectedParty,
    open,
    handleClose,
  }) => {
    const jumboco = useJumboAuth();
    const [ButtonLoadng, setButtonLoadng] = useState(false);
    const [stoneDataDetailData, setStoneDataDetailData] = useState([]);

    const [stoneDataDetail, setStoneDataDetail] = useState(null);
    const [CurrencyName, setCurrencyName] = useState(null);
    const swal = useSwalWrapper();
    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    }));

    useEffect(() => {
      let sdataD = basketData?.filter((sdata) =>
        SelectedStone.includes(sdata.FL_ITEM_CODE)
      );
      setStoneDataDetailData(sdataD);
    }, [SelectedStone]);


    useEffect(() => {
      let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0, amt: 0, amt1: 0 };
      stoneDataDetailData?.forEach((sdata) => {

        tempCal = {
          pcs: tempCal.pcs + 1,
          cts: tempCal.cts + (sdata.CARATS || sdata.FL_GROSS_WT),
          amt: Number(tempCal.amt) + Number(sdata.FL_SALE_AMT),
        };
      });
      tempCal = {
        pcs: tempCal.pcs,
        amt: tempCal.amt?.toFixed(2),
        cts: tempCal.cts,
      };
      tempCal = {
        ...tempCal,
        price: tempCal.amt / tempCal.cts,
      };
      tempCal.pcs != 0 && setStoneDataDetail({ ...tempCal, amt: tempCal.amt });
    }, [basketData, stoneDataDetailData]);

    const handleSubmit = async (values, { resetForm }) => {
      // Handle form submission logic here
      if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
        setButtonLoadng(true);
        // resetForm();
        await jwtAuthAxios
          .post(`transation/jewel/polishOutward`, {
            ...values,
            Party: userSelectedParty,
            transactionType: 35,
            StoneData: stoneDataDetailData,
            isDetail: "Y",
          })
          .then((res) => {
            swal.fire({
              icon: "success",
              text: res.data.message,
            });
            resetForm();
            handleClose();
            fetchBasketdata();
          })
          .catch((e) => {
            swal.fire({
              icon: "error",
              text: "Internal server Error",
            });
          })
          .finally(() => {
            setButtonLoadng(false);
          });
      } else {
        swal.fire({
          icon: "error",
          text: "Please Fill Detail",
        });
      }
    };

    const [initialValues, setInitialValues] = useState({
      shippingNumber: "",
      FL_BANK_CODE: "",
      term: "",
      shipBy: "",
      ShipingCharge: 0,
      CertCharge: 0,
      narration: "",
      OtherCharge: 0,
      is_p: false,
      Discount: 0,
      wat_per: helperdata?.TAX?.FL_TAX_PER,
      FL_CURR_CODE: "2",
      FL_CONV_RATE: jumboco?.curr?.Rate,
    });

    useEffect(() => {
      setInitialValues({
        ...initialValues,
        wat_per: helperdata?.TAX?.FL_TAX_PER,
      });
    }, [helperdata]);

      
    const [userDetails, setUserDetails] = useState(null);

    const isAdmin = Number(userDetails?.FL_ROLE_ID) === 1;
    useEffect(() => {
      try {
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
          setUserDetails(JSON.parse(storedUser));
        }
      } catch (error) {
        console.error("Failed to parse user from localStorage:", error);
        localStorage.removeItem("user");
      }
    }, []);


    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Sold Shipping Information</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, values, setFieldValue, errors, touched }) => (
              <Form onSubmit={handleSubmit}>
                <Grid item xs={12}>
                  <InputLabel>Select Bank</InputLabel>
                  <Field
                    size="small"
                    name="FL_BANK_CODE"
                    InputLabel="Select Bank"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Bank</MenuItem>
                    {helperdata?.leadgerdetail?.map((item) => (
                      <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                    ))}
                  </Field>
                  {errors.FL_BANK_CODE && touched.FL_BANK_CODE && (
                    <div className="error">{errors.FL_BANK_CODE}</div>
                  )}
                </Grid>
                <Grid container spacing={2}>
                  <Grid item lg={6}>
                    <Field
                      name="FL_CURR_CODE"
                      as={TextField}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      select
                      label="Currency Type"
                      fullWidth
                    >
                      {helperdata?.CURR?.map((option) => (
                        <MenuItem
                          key={option.FL_CURRENCY_ID}
                          onClick={(e) => {
                            setCurrencyName(option.FL_CURRENCY_NAME);
                          }}
                          value={option.FL_CURRENCY_ID}
                        >
                          {option.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="FL_CONV_RATE"
                      as={TextField}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      type="number"
                      label="Conv Rate"
                      fullWidth
                    />
                  </Grid>
                </Grid>

                <Field
                  name="term"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Payment Term"
                  fullWidth
                >
                  {helperdata?.TERM?.map((option) => (
                    <MenuItem
                      key={option.FL_TERM_CODE}
                      color="primary"
                      value={option.FL_TERM_CODE}
                    >
                      {option.FL_TERM_NAME}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="shippingNumber"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Shipping Number"
                  fullWidth
                />
                <Field
                  name="shipBy"
                  as={TextField}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  select
                  label="Ship By"
                  fullWidth
                >
                  {helperdata?.SHIPPEDBY?.map((option) => (
                    <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                      {option.FL_PARA_VALUE}
                    </MenuItem>
                  ))}
                </Field>
                <Grid container columnSpacing={2}>
                  <Grid item lg={6}>
                    <Field
                      name="wat_per"
                      disabled={values.is_p != true}
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="vat Charge(%)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="ShipingCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="Shiping Charge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="CertCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="Cert. Charge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Field
                      name="OtherCharge"
                      as={TextField}
                      type="number"
                      min={"0"}
                      defaultValue={"0"}
                      style={{ margin: "5px 0" }}
                      InputProps={{ size: "small" }}
                      InputLabelProps={{ size: "small" }}
                      label="OtherCharge(AMT)"
                      fullWidth
                    />
                  </Grid>
                  <Grid item lg={6}></Grid>
                </Grid>
                <Field
                  name="Discount"
                  as={TextField}
                  type="number"
                  min={"0"}
                  defaultValue={"0"}
                  style={{ margin: "5px 0" }}
                  InputProps={{ size: "small" }}
                  InputLabelProps={{ size: "small" }}
                  label="Discount(-AMT)"
                  fullWidth
                />
                {isAdmin && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Transaction Date"
                      format="MM-DD-YYYY"
                      value={
                        values.FL_TRANS_DATE
                          ? dayjs(values.FL_TRANS_DATE)
                          : null
                      }
                      minDate={
                        helperdata?.finyears?.length
                          ? dayjs(
                            `${helperdata.finyears[0]?.FL_FIN_YEAR?.split("-")[0]}-01-01`,
                          )
                          : undefined
                      }
                      maxDate={dayjs()}
                      onChange={(date, context) => {
                        if (!date || !date.isValid()) {
                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        const today = dayjs();

                        // Future date validation
                        if (date.isAfter(today, "day")) {
                          alert(
                            `Transaction date cannot be greater than ${today.format("MM-DD-YYYY")}.`,
                          );

                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        // Your existing minDate validation
                        const minDate = helperdata?.finyears?.length
                          ? dayjs(
                            `${helperdata.finyears[0]?.FL_FIN_YEAR?.split("-")[0]}-01-01`,
                          )
                          : null;

                        if (minDate && date.isBefore(minDate, "day")) {
                          alert(
                            `Transaction date cannot be before ${minDate.format("MM-DD-YYYY")}.`,
                          );

                          setFieldValue("FL_TRANS_DATE", "");
                          return;
                        }

                        setFieldValue(
                          "FL_TRANS_DATE",
                          date.format("YYYY-MM-DD"),
                        );
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          style: { margin: "7px 0" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
                <InputLabel>Naration</InputLabel>
                <Field
                  size="small"
                  component={TextareaAutosize}
                  name="narration"
                  label="Naration"
                  minRows={3}
                  onChange={(e) => setFieldValue("narration", e.target.value)}
                  style={{ width: "100%" }}
                  fullWidth
                />
                <Field
                  name="is_p"
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          onClick={() =>
                            !values.is_p
                              ? setFieldValue("wat_per", 0)
                              : setFieldValue(
                                "wat_per",
                                helperdata?.TAX?.FL_TAX_PER
                              )
                          }
                          style={{ margin: "5px 0" }}
                          size="small"
                        // checked={field.value}
                        // Add any other Checkbox props here
                        />
                      }
                      label="IS P"
                      fullWidth
                    />
                  )}
                />
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1, mt: 3 }}
                >
                  <Item>Lot: {stoneDataDetail?.pcs || 0}</Item>
                  <Item>CTS {stoneDataDetail?.cts?.toFixed(2) || 0.0}</Item>
                  <Item>vat% {values.wat_per || 0}</Item>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1 }}
                >
                  <Item>
                    ShipingCharge ($AMT) = {values.ShipingCharge || 0}
                  </Item>
                  <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                  <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                  <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{ mb: 1 }}
                >
                  <Item>
                    Total Amt ($) ={" "}
                    {(
                      Number(
                        values.FL_CURR_CODE == 1
                          ? stoneDataDetail?.amt
                          : stoneDataDetail?.amt / jumboco?.curr?.Rate
                      ) +
                      ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                      100 +
                      (values.CertCharge || 0) +
                      (values.OtherCharge || 0) +
                      (values.ShipingCharge || 0) -
                      (values.Discount || 0)
                    ).toFixed(2)}
                  </Item>
                  <Item>
                    Total Amt ({CurrencyName || "RMB"}) =
                    {(
                      Number(
                        values.FL_CURR_CODE == 2
                          ? stoneDataDetail?.amt
                          : (stoneDataDetail?.amt * jumboco?.curr?.Rate)
                      ) +
                      ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                      100 +
                      (values.CertCharge || 0) +
                      (values.OtherCharge || 0) +
                      (values.ShipingCharge || 0) -
                      (values.Discount || 0) * values.FL_CONV_RATE
                    ).toFixed(2)}
                  </Item>
                </Stack>
                <LoadingButton
                  loading={ButtonLoadng}
                  variant="contained"
                  color="primary"
                  sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                  type="submit"
                >
                  Sold
                </LoadingButton>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  };
  const StoneTableViewWIthBasket = ({
    SelectedStoneBasketData,
    setSelectedStoneBasketData,
    Stoneresultdata,
    SelectedStone,
    setSelectedStone,
    setStoneresultdata,
    isedit = false,
  }) => {
    const [selectedStoneDetails, setSelectedStoneDetails] = useState({
      pcs: 0,
      cts: 0,
      rap: 0,
      disc: 0,
    });
    useEffect(()=>{
      let stod={pcs: 0,cts: 0,rap: 0,disc: 0,amt:0}
      document.querySelectorAll('[name="single-stone-sep"]:checked').forEach(e=>{
        let nodeIndex = e.id.split('-')[1]
        stod['pcs'] = stod['pcs']+ 1
        stod['cts'] = stod['cts']+rows[nodeIndex]['CARATS']
        stod['rap'] = stod['rap']+rows[nodeIndex]['RAP_PRICE']
        stod['disc'] = stod['disc']+rows[nodeIndex]['MDISC']
        stod['amt'] = stod['amt']+rows[nodeIndex]['MDISCS']
      })
      stod['disc'] =stod['disc'] /document.querySelectorAll('[name="single-stone-sep"]:checked').length
      stod['rap'] =stod['rap'] /document.querySelectorAll('[name="single-stone-sep"]:checked').length
      setSelectedStoneDetails({ ...stod,price:stod['amt']/stod['cts']});
    },[])
    // useEffect(()=>{
    //   console.log('selectedStoneDetails', selectedStoneDetails)
    // },[selectedStoneDetails])
    
    const [discVal, setDiscVal] = useState({ discType: "ASK_DISC", Disc: 0 });
    const jumboco = useJumboAuth();
    const useStyles = makeStyles((theme) => ({
      RedCell: {
        background: theme.palette.error.main,
        color: "#fff",
      },
      GreenCell: {
        background: "green",
        color: "#fff",
      },
      ASkCell: {
        background: theme.palette.info.main,
        color: "#fff",
      },
    }));
    const classes = useStyles();
    const columns = [

      { field: "STATUS", flex: 1, headerName: "Status" },
      { field: "STONE", flex: 1, headerName: "StoneId" },
      { field: "RAP_PRICE", flex: 1, type: "number", headerName: "Rap($)" },
      {
        field: "MDISC",
        type: "number",
        flex: 1,
        headerName: "Discount(%)",
        cellClassName: "editable-cell",
        editable: true,
        renderCell: ({ row, value }) =>
          Number(value)?.toFixed(2) && Number(value)?.toFixed(2),
      },
      {
        field: "MDISCP",
        type: "number",
        flex: 1,
        headerName: "Price($)",
        cellClassName: "editable-cell",
        editable: true,
        renderCell: ({ row, value }) =>
          value?.toFixed(2) ||
          Number(row.RAP_PRICE - (row.RAP_PRICE * row.MDISC) / 100)?.toFixed(2),
      },
      {
        field: "MDISCS",
        type: "number",
        flex: 1,
        headerName: "Amount($)",
        cellClassName: "editable-cell",
        editable: true,
        renderCell: ({ row, value }) =>
          value?.toFixed(2) ||
          Number(
            (row.RAP_PRICE - (row.RAP_PRICE * row.MDISC) / 100) * row.CARATS
          )?.toFixed(2),
      },
      {
        field: "MDISC2",
        type: "number",
        flex: 1,
        headerName: "Amount(RMB)",
        cellClassName: "editable-cell",
        editable: true,
        renderCell: ({ row, value }) =>
          jumboco?.curr?.cd +
          "" +
          (value?.toFixed(2) ||
            (
              jumboco?.curr?.Rate *
              Number(
                (row.RAP_PRICE - (row.RAP_PRICE * row.MDISC) / 100) * row.CARATS
              )
            )?.toFixed(2)),
      },
      {
        field: "PARTY",
        flex: 1,
        headerName: "Party",
        headerClassName: "TopHeader",
        renderCell: (params) => (params.value == " ()" ? "-" : params.value),
      },
      { field: "LAB", flex: 1, headerName: "Lab" },
      { field: "REPORTNO", flex: 1, headerName: "ReportNO" },
      { field: "SHAPE", flex: 1, headerName: "Shape" },
      { field: "CARATS", flex: 1, headerName: "Carats" },
      { field: "COLOR", flex: 1, headerName: "Color" },
      { field: "CLARITY", flex: 1, headerName: "Clarity" },
      // { field: 'MDISC2', headerName: 'Amount(RMB)',renderCell: (row) => jumboco?.curr?.cd +''+ (jumboco?.curr?.Rate *  Number(((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100) * row.CARATS)).toFixed(2)).toFixed(2) },

      // { field: 'ASK_DISC', headerName: 'ASK($)', renderCell: ({ row }) => (`${(row.RAP_PRICE - (row.RAP_PRICE * (row.ASK_DISC)) / 100).toFixed(2)}/${row.ASK_DISC}`),cellClassName: classes.ASkCell },
      // { field: 'GREEN_DISC', headerName: 'GREEN($)', renderCell: ({ row }) => (`${(row.RAP_PRICE - (row.RAP_PRICE * (row.GREEN_DISC)) / 100).toFixed(2)}/${row.GREEN_DISC}`),cellClassName: classes.GreenCell },
      // { field: 'RED_DISC', headerName: 'RED($)', renderCell: ({ row }) => (`${(row.RAP_PRICE - (row.RAP_PRICE * (row.RED_DISC)) / 100).toFixed(2)}/${row.RED_DISC}`) ,cellClassName: classes.RedCell}
    ];


    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    }));
    // useEffect(() => {
    //   if (SelectedStone && Stoneresultdata) {
    //     let ndata = SelectedStone?.flatMap((stone) =>
    //       Stoneresultdata?.filter((s) => s.STONE === stone)
    //     );
    //     // console.log(ndata);
    //     let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0, amt2: 0, amt1: 0 };
    //     ndata?.forEach((sdata) => {
    //       // console.log(sdata);
    //       tempCal = {
    //         pcs: tempCal.pcs + 1,
    //         cts: tempCal.cts + sdata.CARATS,
    //         rap: Number(tempCal.rap) + Number(sdata.RAP_PRICE),
    //         disc: Number(tempCal.disc) + Number(sdata.MDISC),
    //         amt1:
    //           Number(tempCal.amt1) +
    //           Number(
    //             sdata.MDISCS ||
    //             ((sdata.RAP_PRICE * (100 - sdata.MDISC)) / 100) * sdata.CARATS
    //           ),
    //       };
    //     });
    //     // console.log(tempCal);
    //     tempCal = {
    //       pcs: tempCal.pcs,
    //       amt1: tempCal.amt1,
    //       cts: tempCal.cts,
    //       rap: Number(tempCal.rap) / Number(tempCal.pcs),
    //       disc: Number(tempCal.disc) / Number(tempCal.pcs),
    //     };
    //     // alert(tempCal.amt1+'-'+tempCal.cts)
    //     tempCal = {
    //       ...tempCal,
    //       price: tempCal.amt1 / tempCal.cts, //Number(tempCal.rap) - (tempCal.rap * tempCal.disc / 100)
    //     };
    //     // console.log(tempCal);
    //     tempCal.pcs != 0 &&
    //       setSelectedStoneDetails({ ...tempCal, amt: tempCal.amt1 });
    //   }
    // }, [SelectedStone, Stoneresultdata]);

    const handlediscChang = async (e, stone, type) => {
      let tmpStoneData = stone;
      let targetData = e.target?.id.split("-");
      // console.log(targetData);
      // console.log(e.target.id);
      if (type == 0) {
        let disc = e.target.value;
        tmpStoneData = { ...tmpStoneData, MDISC: disc };
      } else if (type == 1) {
        tmpStoneData = {
          ...tmpStoneData,
          MDISC: 100 - (e.target.value * 100) / stone.RAP_PRICE,
        };
      } else if (type == 2) {
        let tmpAMT = e.target.value / stone.CARATS;
        tmpStoneData = {
          ...tmpStoneData,
          MDISC: 100 - (tmpAMT * 100) / stone.RAP_PRICE,
        };
      }
      let ManageStoneDisc = Stoneresultdata?.filter(
        (sd) => sd.STONE !== stone.STONE
      );
      let tmpprice =
        stone.RAP_PRICE - (stone.RAP_PRICE * tmpStoneData.MDISC) / 100;
      let FinalObj = {
        ...tmpStoneData,
        mPrice: tmpprice,
        mamt: tmpprice * stone.CARATS,
      };
      ManageStoneDisc.push(FinalObj);
      // console.log('type',type != 1 ,typeof(type));
      // console.log(FinalObj.mPrice?.toFixed(2));
      // Sort the array by the STONE property in ascending order
      ManageStoneDisc.sort((a, b) => (a.STONE > b.STONE ? 1 : -1));
      if (type !== 0) {
        document.getElementById(`${targetData[0]}-0-${targetData[2]}`).value =
          FinalObj?.MDISC?.toFixed(2);
      }
      if (type !== 1) {
        document.getElementById(`${targetData[0]}-1-${targetData[2]}`).value =
          FinalObj.mPrice?.toFixed(2);
      }
      if (type !== 2) {
        document.getElementById(`${targetData[0]}-2-${targetData[2]}`).value =
          FinalObj.mamt?.toFixed(2);
      }
      // Set the sorted array to the state (assuming you're using React useState)
      setStoneresultdata(ManageStoneDisc);
    };
    const discvalHandler = async () => {
      let updatedData = basketData.map((data) => {
        if (SelectedStone.includes(data.STONE)) {
          return {
            ...data,
            MDISC: Number(discVal.Disc),
          };
        }
        return data; // Return unchanged items
      });
      setStoneresultdata(updatedData);
    };
    const handleCellEditCommit = (params) => {
      // const updatedRows = rows.map((row) =>
      //     row.id === params.id ? { ...row, [params.field]: params.value } : row
      // );
      // setRows(updatedRows);
      console.log(params); // Retrieve the updated value here
    };
    // return(

    // )
    const [rows, setRows] = useState(Stoneresultdata || []);

    const handleEditCellChange = (params) => {
      console.log(params);
      return;
      // Access the updated row and change the values of all fields
      const updatedRows = rows.map((row) => {
        if (row.id === params.id) {
          return { ...row, [params.field]: params.props.value };
        }
        return row;
      });
      setRows(updatedRows);
    };
    const handleStoneSelect = (stone) => {
      // console.log(SelectedStone.indexOf(stone));
      // if (SelectedStone.indexOf(stone) === -1) {
      // If the stone is not in SelectedStone, add it
      setSelectedStone(stone);
      // } else {
      //   // If the stone exists in SelectedStone, remove it
      //   const updatedStones = SelectedStone.filter((s) => s !== stone);
      //   setSelectedStone(updatedStones);
      // }
    };
    let updated_field = [];
    // const stonevalhandler = (event) => {
    //   const { name, value } = event.target;
    //   const nodeIndex = event.target.getAttribute('row_index');
    //   const [prefix, index, stoneid, field] = name.split('-');
    //   const updatedRows = [...rows];
    //   const data = updatedRows[nodeIndex];
    
    //   const newValue = parseFloat(value);
    
    //   switch (field) {
    //     case 'MDISC':
    //       data.MDISCP = (data.RAP_PRICE * ((100 - newValue) / 100))?.toFixed(2);
    //       data.MDISCS = (data.MDISCP * data.CARATS)?.toFixed(2);
    //       data.MDISC2 = (data.MDISCS * jumboco?.curr?.Rate)?.toFixed(2);
    //       break;
    
    //     case 'MDISCP':
    //       data.MDISC = (100 - (newValue * 100 / data.RAP_PRICE))?.toFixed(2);
    //       data.MDISCS = (newValue * data.CARATS)?.toFixed(2);
    //       data.MDISC2 = (data.MDISCS * jumboco?.curr?.Rate)?.toFixed(2);
    //       break;
    
    //     case 'MDISCS':
    //       data.MDISC = (100 - (((newValue / data.CARATS) * 100) / data.RAP_PRICE))?.toFixed(2);
    //       data.MDISCP = (newValue / data.CARATS)?.toFixed(2);
    //       data.MDISC2 = (newValue * jumboco?.curr?.Rate)?.toFixed(2);
    //       break;
    
    //     case 'MDISC2':
    //       data.MDISC = (100 - ((((newValue / jumboco?.curr?.Rate) / data.CARATS) * 100) / data.RAP_PRICE))?.toFixed(2);
    //       data.MDISCP = ((newValue / jumboco?.curr?.Rate) / data.CARATS)?.toFixed(2);
    //       data.MDISCS = (newValue / jumboco?.curr?.Rate)?.toFixed(2);
    //       break;
    
    //     case 'RAP_PRICE':
    //       data.MDISCP = (data.RAP_PRICE * ((100 - data.MDISC) / 100))?.toFixed(2);
    //       data.MDISCS = (data.MDISCP * data.CARATS)?.toFixed(2);
    //       data.MDISC2 = (data.MDISCS * jumboco?.curr?.Rate)?.toFixed(2);
    //       break;
    
    //     default:
    //       break;
    //   }
    
    //   updatedRows[nodeIndex] = data;
    //   setRows(updatedRows);
    
    //   if (!updated_field.includes(name)) {
    //     updated_field.push(name);
    //   }
    // };
    
    const stonevalhandler = (event) => {
      const { name, value } = event.target;
      let nodeIndex = event.target.getAttribute('row_index')
      // console.log(nodeIndex,);
      const [prefix, index, stoneid, field] = name.split('-');
      // let updatedStone = rows
      let data = rows[nodeIndex]
      data[field] =value;
      if (field == 'MDISC') {
        console.log('MDISC', (data['RAP_PRICE'] * ((100 - value) / 100)))
        data['MDISC'] = value;
        let rate = (data['RAP_PRICE'] * ((100 - value) / 100))
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCP`)[0].value = rate?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCS`)[0].value = (rate * data['CARATS'])?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC2`)[0].value = ((rate * data['CARATS']) * jumboco?.curr?.Rate)?.toFixed(2)
      } else if (field == 'MDISCP') {
        data['MDISC'] = 100 - (value * 100 / data['RAP_PRICE']);
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC`)[0].value = data['MDISC']?.toFixed(2)
        // document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCP`)[0].value =data['MDISCP']?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCS`)[0].value = (value *  data['CARATS'])?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC2`)[0].value = (value *  data['CARATS'] * jumboco?.curr?.Rate)?.toFixed(2)
        // let rap = '';
        // console.log('MDISCP', disc)
      } else if (field == 'MDISCS') {
        data['MDISC'] = 100 - (((value / data['CARATS']) * 100 / data['RAP_PRICE']));
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC`)[0].value = data['MDISC']?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCP`)[0].value = (value /  data['CARATS'])?.toFixed(2) //data['MDISCP']?.toFixed(2)
        // document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCS`)[0].value =data['MDISCS']?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC2`)[0].value = (value * jumboco?.curr?.Rate)?.toFixed(2)
        // let rap = '';
        // console.log('MDISCS', disc,`${prefix}-${index}-${stoneId}-MDISC`)
      } else if (field == 'MDISC2') {
        data['MDISC'] = 100 - ((((value / jumboco?.curr?.Rate) / data['CARATS']) * 100 / data['RAP_PRICE']));
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC`)[0].value = data['MDISC']?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCP`)[0].value = ((value /  data['CARATS'])/jumboco?.curr?.Rate)?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCS`)[0].value = (value/jumboco?.curr?.Rate)?.toFixed(2)
        // document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC2`)[0].value =data['MDISC2']?.toFixed(2)
        // let rap = '';
        // console.log('MDISC2', disc)
      }  else if (field == 'RAP_PRICE') {
        data['MDISCP'] = value*( (100 - Number(data['MDISC']))/100)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC`)[0].value = data['MDISC']?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCP`)[0].value = data['MDISCP']?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCS`)[0].value = (data['MDISCP'] * data['CARATS'])?.toFixed(2)
        document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC2`)[0].value = ((data['MDISCP'] * data['CARATS'])*jumboco?.curr?.Rate )?.toFixed(2)
      }
      data['RAP_PRICE']= Number(document.getElementsByName(`single-${nodeIndex}-${stoneid}-RAP_PRICE`)[0].value)
      data['MDISC']= Number(document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC`)[0].value)
      data['MDISCP']= Number(document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCP`)[0].value)
      data['MDISCS']=Number(document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISCS`)[0].value)
      data['MDISC2']=Number(document.getElementsByName(`single-${nodeIndex}-${stoneid}-MDISC2`)[0].value)
      let updatedStone = rows;
      updatedStone[nodeIndex] = data;
      
      setRows(updatedStone)
      document.getElementById(`single-${nodeIndex}-${stoneid}`).checked && handlestoneCheckSingleStone()
      updated_field.indexOf(name) === -1 && updated_field.push(name);

      // console.log(`rows[nodeIndex]['field']`,rows[nodeIndex][field],'updated_field',updated_field);
      // const updatedData = rows.map((row) => {
      //   if (row.STONE === stoneId) {
      //     const newRow = { ...row, [field]: parseFloat(value) };

      //     if (field === 'MDISCP') {
      //       // Calculate MDISCS and MDISC2 based on MDISCP
      //       newRow.MDISCS = Number(newRow.MDISCP) * Number(row.CARAT);
      //       newRow.MDISC2 = Number(newRow.MDISCS) * 7.25;
      //     } else if (field === 'MDISCS') {
      //       // Calculate MDISCP and MDISC2 based on MDISCS
      //       newRow.MDISCP = Number(newRow.MDISCS) / Number(row.CARAT);
      //       newRow.MDISC2 = Number(newRow.MDISCS) * 7.25;
      //     } else if (field === 'MDISC2') {
      //       // Calculate MDISCS based on MDISC2 and conversion rate
      //       newRow.MDISCS = Number(newRow.MDISC2) / 7.25;
      //       newRow.MDISCP = Number(newRow.MDISCS) / Number(row.CARAT);
      //     }

      //     // console.log(newRow);
      //     return newRow;
      //   }
      //   return row;
      // });
      // setRows(updatedStone);
    }
    const handleSelectAllCheckSingleStone=(ev)=>{
      
      let stod= {
        pcs: 0,
        cts: 0,
        rap: 0,
        disc: 0,
        amt: 0,
      }
      // const id = ev?.target?.id?.split('-')[2];
      console.log(rows?.length , SelectedStone?.length)
if(document.querySelectorAll('[name="single-stone-sep"]:not([disabled])')?.length == SelectedStone?.length){
  setSelectedStone([])
}else{
      // id &&  setSelectedStone((sset) => {
      //   if (ev?.target?.checked) {
      //     // Add the item if it's not already in the array
      //     return sset.includes(id) ? sset : [...sset, id];
      //   } else {
      //     // Remove the item if it's in the array
      //     return sset.filter((item) => item !== id);
      //   }
      // });
        
      let _selectedStonesAllD = [];
      document.querySelectorAll('[name="single-stone-sep"]:not([disabled])').forEach(e=>{
        let nodeIndex = e.id.split('-')[1]
        _selectedStonesAllD.push(rows[nodeIndex]['STONE']);
        stod['pcs'] = stod['pcs']+ 1
        stod['cts'] = stod['cts']+rows[nodeIndex]['CARATS']
        stod['rap'] = stod['rap']+rows[nodeIndex]['RAP_PRICE']
        stod['disc'] = stod['disc']+rows[nodeIndex]['MDISC']
        stod['amt'] = stod['amt']+rows[nodeIndex]['MDISCS']
      })
      stod['disc'] =stod['disc'] /_selectedStonesAllD.length
      stod['rap'] =stod['rap'] /_selectedStonesAllD.length
       console.log({ ...stod,price:stod['amt']/stod['cts']})
       setSelectedStone(_selectedStonesAllD);
       setSelectedStoneDetails({ ...stod,price:stod['amt']/stod['cts']});
    }
      
}
    const handlestoneCheckSingleStone = (ev=null)=>{
     let stod= {
        pcs: 0,
        cts: 0,
        rap: 0,
        disc: 0,
        amt: 0,
      }
      const id = ev?.target?.id?.split('-')[2];

      id &&  setSelectedStone((sset) => {
        if (ev?.target?.checked) {
          // Add the item if it's not already in the array
          return sset.includes(id) ? sset : [...sset, id];
        } else {
          // Remove the item if it's in the array
          return sset.filter((item) => item !== id);
        }
      });
        
      
      document.querySelectorAll('[name="single-stone-sep"]:checked').forEach(e=>{
        let nodeIndex = e.id.split('-')[1]
        stod['pcs'] = stod['pcs']+ 1
        stod['cts'] = stod['cts']+rows[nodeIndex]['CARATS']
        stod['rap'] = stod['rap']+rows[nodeIndex]['RAP_PRICE']
        stod['disc'] = stod['disc']+rows[nodeIndex]['MDISC']
        stod['amt'] = stod['amt']+rows[nodeIndex]['MDISCS']
      })
      stod['disc'] =stod['disc'] /document.querySelectorAll('[name="single-stone-sep"]:checked').length
      stod['rap'] =stod['rap'] /document.querySelectorAll('[name="single-stone-sep"]:checked').length      
      setSelectedStoneDetails({ ...stod,price:stod['amt']/stod['cts']});
    }
    const manageExcelSingle = async (e) => {
      let data = window.prompt('Paste Excel Data Without Heading in This Formate (StoneID, amount(RMB)) System Will Auto Calculate Total Amount and Price per Carat and Discount according to the data you provided');
      if(!data){
        return;
      }
      // Split the data into rows and columns
      const rowsData = data?.split(/\r?\n/).filter(row => row.trim() !== '');
      const parsedData = rowsData?.map(row => row.split('\t'));
    
      // Assuming 'rows' is your existing data array
      let basketTableData = rows.filter(r => parsedData.findIndex(i => i[0] == r.STONE) !== -1);
      let basketNotTableData = parsedData.filter(r => rows.findIndex(i => i.STONE == r[0]) === -1).map(m=>m[0]).join(',');
    if(basketNotTableData){
      console.log('basketNotTableData', basketNotTableData)
      alert('This  data is not in the basket, please add it first '+basketNotTableData);
    } else{
      let _PbasketDataStondeIDS =basketTableData.map(bt=> bt.STONE)
      let _BasketRowData = rows.map((row,nodeIndex)=>{
        if(_PbasketDataStondeIDS.includes(row.STONE)){
          let selctedEXDATA=  parsedData.find(i => i[0] == row.STONE);
          let MDISCS=Number(selctedEXDATA[1])/jumboco?.curr?.Rate;
          let MDISCP= MDISCS/row?.CARATS
          let MDISC= 100-((MDISCP*100)/row?.RAP_PRICE)
          let resData ={
            MDISC2:Number(selctedEXDATA[1]),MDISCS,MDISCP,MDISC
          }
          console.log(`single-${nodeIndex}-${row['STONE']}`);
          
          console.log('MDISC', document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISC`)[0].value)
          document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISC`)[0].value = MDISC
          console.log('MDISCP', document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISCP`)[0].value)
          document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISCP`)[0].value = MDISCP
          console.log('MDISCS', document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISCS`)[0].value)
          document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISCS`)[0].value = MDISCS
          console.log('MDISC2', document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISC2`)[0].value)
          document.getElementsByName(`single-${nodeIndex}-${row['STONE']}-MDISC2`)[0].value = selctedEXDATA[1]
          // console.log(row);
          return ({...row,...resData})
        } else{
          return row
        }
      })
      console.log(_BasketRowData);
      setSelectedStone(_PbasketDataStondeIDS);
      setStoneresultdata(_BasketRowData)
     setRows(_BasketRowData)
    }
    };
    
    return (
      <>
        {Array.isArray(Stoneresultdata) && (
          <Stack
            direction="row"
            overflow={"auto"}
            divider={<Divider orientation="vertical" flexItem />}
            spacing={2}
            sx={{ mb: 1, py: 2, textWrap: "nowrap" }}
          >
            <Item>Pcs = {selectedStoneDetails.pcs || 0}</Item>
            <Item>CTS = {selectedStoneDetails.cts?.toFixed(2) || 0.0}</Item>
            <Item>Rap = {selectedStoneDetails.rap.toFixed(2) || 0}</Item>
            <Item>Disc% = {selectedStoneDetails.disc?.toFixed(2) || 0}</Item>
            <Item>Price = {selectedStoneDetails.price?.toFixed(2) || 0}</Item>
            <Item>Amt ($) = {selectedStoneDetails.amt?.toFixed(2) || 0}</Item>
            <Item>
              Amt (RMB) ={" "}
              {jumboco?.curr?.cd +
                "" +
                (jumboco?.curr?.Rate * selectedStoneDetails.amt || 0)?.toFixed(
                  2
                ) || 0}
            </Item>
            <div style={{ marginLeft: "auto" }}>
              {/* <Stack direction="row" spacing={2}>

                <TextField
                  fullWidth
                  size="small"
                  name="Disc"
                  label="Disc %"
                  value={discVal.Disc}
                  onChange={(e) =>
                    setDiscVal({ ...discVal, Disc: e.target.value })
                  }
                  type="number"
                  sx={{ minWidth: "150px" }}
                />
                <Button
                  variant="outlined"
                  onClick={discvalHandler}
                  disabled={discVal == null}
                  color="primary"
                >
                  DISC
                </Button> 
              </Stack>*/}
               <Button
                  variant="outlined"
                  onClick={manageExcelSingle}
                  color="primary"
                >
                  Paste Data
                </Button> 
            </div>
          </Stack>
        )}
        {/* <Button onClick={getFieldValue(params.id, 'MDISC')}>click</Button> */}
        <TableContainer component={Paper}>
          <Paper style={{ width: '100%' }}>
            <Table size="small" border={1}>
              <TableHead>
                <TableRow>
                  <TableCell>

                    <FormControlLabel
                      // label="Parent"
                      onClick={handleSelectAllCheckSingleStone}
                      control={
                        <Checkbox
                          checked = {rows?.length == SelectedStone?.length}
                          indeterminate={rows?.length != SelectedStone?.length && SelectedStone?.length > 0}
                        />
                      }
                    />
                  </TableCell>
                  {columns?.map(c => { return <TableCell>{[c.headerName]}</TableCell> })}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((r, i) => {
                  return <TableRow>
                    <TableCell sx={{ p: 0, width: 'min-content' }}>
                      <Checkbox
                      name={`single-stone-sep`}
                      disabled={r.STATUS != 'A'}
                      id={`single-${i}-${r.STONE}`}
                      checked={SelectedStone?.indexOf(r.STONE) != -1}
                      onChange={handlestoneCheckSingleStone}
                      inputProps={{ 'aria-label': `single-${i}-${r.STONE}` }}  />
                    </TableCell>
                    {
                      columns?.map(c => {
                        return <>{(c.field == 'MDISCP' || c.field == 'MDISCS' || c.field == 'MDISC' || c.field == 'RAP_PRICE' || c.field == 'MDISC2') ?
                          <TableCell sx={{ p: 0, width: 'min-content' }}>
                            <input type="number" min="0" style={{ minHeight: '33px', borderRadius: '4px', padding: '4px 3px', width: '110px' }} name={`single-${i}-${r.STONE}-${c.field}`} row_index={i} onInput={stonevalhandler} stoneid={r.STONE} defaultValue={r[c.field]?.toFixed(2)} /></TableCell> : <TableCell> {r[c.field]}</TableCell>}</>
                      })
                    }</TableRow>
                })
                }

              </TableBody>
            </Table>
            {/* <DataGrid
              rows={rows || []}
              columns={columns}
              apiRef={gridRef}
              // onRowEditStop={(params) => getFieldValue(params)}
              // onEditRowsModelChange={handleEditCellChange}
              // onEditCellChange={handleEditCellChange}

              rowSelectionModel={SelectedStone}
              onRowSelectionModelChange={handleStoneSelect}
              onCellEditCommit={handleCellEditCommit}
              // onCellEditStop={handleCellEditCommit}
              // onRowEditCommit={handleCellEditCommit}
              // isCellEditable={(params) => params.row.STATUS == "A"}
              // isRowSelectable={(params) => params.row.STATUS == "A"}
              density="compact"
              editMode="row"
              getRowId={(row) => row.STONE}
              checkboxSelection={(params) => params.row.STATUS == "A"}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 100,
                  },
                },
              }}
              // pageSizeOptions={[50,100,300]}
              // checkboxSelection
              disableRowSelectionOnClick
            /> */}
          </Paper>

        </TableContainer>
      </>
    );
  };
  const StoneTableWithBasket = ({
    stoneResult,
    SelectedStone,
    SelectedStoneBasketData,
    setSelectedStoneBasketData,
    Stoneresultdata,
    setStoneresultdata,
    setSelectedStone,
  }) => {
    const columns = [
      { field: "FL_MAIN_LOT", flex: 1, headerName: "Lot NO." },
      { field: "FL_SUB_LOT", flex: 1, headerName: "Sub Lot" },
      { field: "FL_SHAPE", flex: 1, headerName: "Shape" },
      { field: "FL_COLOR", flex: 1, headerName: "Color" },
      { field: "FL_CLARITY", flex: 1, headerName: "Calrity" },
      {
        field: "FL_SELL_CARATS",
        flex: 1,
        headerName: "Carats To Sell",
        cellClassName: "editable-cell",
        editable: true,
        type: "number",
        className: "sell_bulk_carats",
        styled: { backgroundColor: "black" },
      },
      {
        field: "FL_RATE2",
        flex: 1,
        editable: true,
        cellClassName: "editable-cell",
        headerName: "Total Amt(" + jumboco?.curr?.cd + ")",
        type: "number",
        renderCell: ({ row }) =>
          ((row.FL_RATE || 0) * jumboco?.curr?.Rate)?.toFixed(2),
      },
      {
        field: "FL_RATE",
        flex: 1,
        headerName: "Total Rate($)",
        type: "number",
      },
      {
        field: "FL_LOT_VAL2",
        flex: 1,
        headerName: "Rate(" + jumboco?.curr?.cd + ")",
        type: "number",
        renderCell: (params) =>
          `${(params.row.FL_RATE2 / params.row.FL_SELL_CARATS || 0)?.toFixed(
            2
          )} ${jumboco?.curr?.cd}`,
      },
      {
        field: "FL_LOT_VAL",
        flex: 1,
        headerName: "Rate($)",
        type: "number",
        renderCell: (params) =>
          `${(params.row.FL_RATE / params.row.FL_SELL_CARATS || 0)?.toFixed(
            2
          )} $`,
      },
      {
        field: "FL_CARATS",
        flex: 1,
        headerName: "Available Carats",
        type: "number",
      },
      { field: "FL_ASK_AMT", flex: 1, headerName: "Ask Rate", type: "number" },
      {
        field: "FL_GREEN_AMT",
        flex: 1,
        headerName: "Green Rate",
        type: "number",
      },
      { field: "FL_RED_AMT", flex: 1, headerName: "Red Rate", type: "number" },
    ];
    const handleCellEdit = async (params) => {
      // alert(params.field);
      setTimeout(async () => {
        let rowval = gridRef.current.getRow(params.id);

        const updatedRows = Stoneresultdata.map((row) => {
          if (row.FL_SUB_LOT === params.id) {

            return {
              ...rowval,
              FL_SELL_CARATS:
                rowval.FL_SELL_CARATS <= row.FL_CARATS
                  ? rowval.FL_SELL_CARATS
                  : row.FL_CARATS,
              FL_RATE: rowval.FL_RATE2 / jumboco?.curr?.Rate,
            };
          }
          return row;
        });
        setStoneresultdata(updatedRows);
      }, 100);
    };
    const gridRef = useRef(null);
    return (
      <Paper>
        <DataGrid
          rows={Stoneresultdata || []}
          columns={columns}
          autoHeight
          editMode="row"
          apiRef={gridRef}
          id={"bulk_basket_table"}
          rowSelectionModel={SelectedStone}
          onRowEditStop={handleCellEdit}
          onRowSelectionModelChange={(e) => setSelectedStone(e)}
          density="compact"
          isRowSelectable={(params) => Boolean(params.row.FL_SELL_CARATS)}
          checkboxSelection={(params) => Boolean(params.row.FL_SELL_CARATS)}
          getRowId={(row) => row.FL_SUB_LOT}
          disableColumnSelector
          disableRowSelectionOnClick
        />
      </Paper>
    );
  };

  const JewelryTableWithBasket = ({
    stoneResult,
    SelectedStone,
    SelectedStoneBasketData,
    setSelectedStoneBasketData,
    Stoneresultdata,
    setStoneresultdata,
    setSelectedStone,
  }) => {
    const columns = [
      { field: "FL_ITEM_CODE", flex: 1, headerName: "Item Code." },
      { field: "FL_CATGORY", flex: 1, headerName: "Catgory" },
      { field: "FL_QUALITY", flex: 1, headerName: "Quality" },
      { field: "FL_GROSS_WT", flex: 1, headerName: "Gross Wt" },
      { field: "FL_NET_WT", flex: 1, headerName: "Net Wt" },
      { field: "FL_DIAM_PCS", flex: 1, headerName: "Diamond Pcs" },
      { field: "FL_DIAM_CTS", flex: 1, headerName: "Diamond Cts" },
      { field: "FL_STATUS", flex: 1, headerName: "Status" },
      {
        field: "FL_SALE_AMT",
        flex: 1,
        headerName: "Sale Amount",
        cellClassName: "editable-cell",
        editable: true,
        type: "number",
        className: "sell_bulk_carats",
        styled: { backgroundColor: "black" },
        renderCell: ({ row, value }) =>
          Number(value)?.toFixed(2) && Number(value)?.toFixed(2),
      },
    ];

    const handleCellEdit = async (params) => {
      setTimeout(async () => {
        let rowval = apiRef.current.getRow(params.id);
        const updatedRows = Stoneresultdata.map((row) => {
          if (row.FL_ITEM_CODE === params.id) {
            return {
              ...rowval,
              FL_SALE_AMT: rowval.FL_SALE_AMT,
            };
          }
          return row;
        });
        setStoneresultdata(updatedRows);
      }, 100);
    };
    const apiRef = useRef(null);

    return (
      <Paper>
        <DataGrid
          rows={Stoneresultdata || []}
          columns={columns}
          autoHeight
          editMode="row"
          apiRef={apiRef}
          id={"FL_ITEM_CODE"}
          rowSelectionModel={SelectedStone}
          onRowEditStop={handleCellEdit}
          onRowSelectionModelChange={(e) => setSelectedStone(e)}
          density="compact"
          getRowId={(row) => row.FL_ITEM_CODE}
          disableColumnSelector
          disableRowSelectionOnClick
          isCellEditable={(params) => params.row.FL_STATUS == "A"}
          isRowSelectable={(params) => params.row.FL_STATUS == "A"}
          checkboxSelection={(params) => params.row.FL_STATUS == "A"}
        />
      </Paper>
    );
  };
  return (
    <div>
      <Grid container>
        <Grid item lg={7} xs={12}>
          <Stack
            direction={"row"}
            rowGap={1.5}
            flexWrap={"wrap"}
            spacing={0}
            columnGap={2}
            justifyContent="start"
            alignItems="center"
          >
            <LoadingButton
              variant={inventoryType == "single" ? "contained" : "outlined"}
              onClick={() => {
                setBasketData(null);
                setInventoryType("single");
              }}
              sx={{ display: "flex" }}
              startIcon={isMobile ? "" : <DiamondIcon />}
              color="primary"
            >
              {isMobile ? <DiamondIcon /> : "Polish Single"}
            </LoadingButton>
            <LoadingButton
              variant={inventoryType == "bulk" ? "contained" : "outlined"}
              onClick={() => {
                setBasketData(null);
                setInventoryType("bulk");
              }}
              sx={{ display: "flex" }}
              startIcon={
                isMobile ? (
                  ""
                ) : (
                  <svg
                    width="16"
                    height="14"
                    viewBox="0 0 750 750"
                    fill="none"
                    className="btn-svg"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M375 0C167.9 0 0 167.9 0 375C0 582.1 167.9 750 375 750C582.1 750 750 582.1 750 375C750 167.9 582.1 0 375 0ZM375 25C567.988 25 725 182.012 725 375H25C25 182.012 182.012 25 375 25Z"
                      fill="#7C8689"
                    />
                  </svg>
                )
              }
              color="primary"
            >
              {isMobile ? (
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 750 750"
                  fill="none"
                  className="btn-svg"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M375 0C167.9 0 0 167.9 0 375C0 582.1 167.9 750 375 750C582.1 750 750 582.1 750 375C750 167.9 582.1 0 375 0ZM375 25C567.988 25 725 182.012 725 375H25C25 182.012 182.012 25 375 25Z"
                    fill="#7C8689"
                  />
                </svg>
              ) : (
                "Polish Parcel"
              )}
            </LoadingButton>
            <LoadingButton
              variant={inventoryType == "jewel" ? "contained" : "outlined"}
              onClick={() => {
                setBasketData(null);
                setInventoryType("jewel");
              }}
              sx={{ display: "flex" }}
              startIcon={
                isMobile ? (
                  ""
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 693 800"
                    fill="none"
                    className="btn-svg"
                  >
                    <path
                      d="M162.479 62.1786C165.143 64.8427 169.139 67.5053 173.134 67.5053C175.798 67.5053 178.461 66.174 179.793 66.174C186.453 62.1786 187.784 54.1878 183.789 47.5282L157.152 7.57403C153.157 0.914482 145.166 -0.416804 138.506 3.57862C133.18 7.57403 131.847 15.5649 135.842 22.2244L162.479 62.1786Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M625.948 174.05C629.943 174.05 632.607 172.719 635.27 170.055L675.224 130.101C680.551 124.774 680.551 116.783 675.224 111.455C669.897 106.128 661.906 106.128 656.578 111.455L616.624 151.409C611.297 156.736 611.297 164.727 616.624 170.055C619.29 172.719 621.952 174.05 625.948 174.05Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M49.2781 111.455C43.9514 106.128 35.9606 106.128 30.6323 111.455C25.3041 116.782 25.3056 124.773 30.6323 130.101L70.5865 170.055C73.2507 172.719 75.9132 174.05 79.9086 174.05C83.9041 174.05 86.5682 172.719 89.2308 170.055C94.5575 164.728 94.5575 156.737 89.2308 151.409L49.2781 111.455Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M511.415 64.843C514.079 66.1743 516.742 67.5071 519.406 67.5071C523.401 67.5071 527.397 64.843 530.061 60.8476L556.698 20.8934C560.692 14.2338 559.36 6.24298 552.701 2.24756C546.041 -1.74786 538.05 -0.416573 534.055 6.24298L507.418 46.1972C503.424 52.8567 504.756 60.8476 511.415 64.843Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M531.389 740.069C527.393 733.41 519.403 732.078 512.743 736.074C506.083 740.069 504.752 748.06 508.748 754.72L535.384 794.674C538.048 797.338 542.044 800 546.039 800C548.703 800 551.366 798.669 554.03 798.669C560.69 794.674 562.021 786.683 558.025 780.023L531.389 740.069Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M57.2656 630.859L17.3114 670.813C11.9847 676.14 11.9847 684.131 17.3114 689.459C19.9756 692.123 22.6381 693.455 26.6336 693.455C30.629 693.455 33.2931 692.123 35.9557 689.459L75.9099 649.505C81.2366 644.178 81.2366 636.188 75.9099 630.859C70.5832 625.533 62.5923 625.533 57.2656 630.859Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M621.953 630.859C616.627 625.533 608.636 625.533 603.308 630.859C597.981 636.186 597.981 644.177 603.308 649.505L643.262 689.459C645.926 692.123 648.588 693.455 652.584 693.455C656.579 693.455 659.243 692.123 661.906 689.459C667.233 684.133 667.233 676.142 661.906 670.813L621.953 630.859Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M179.796 734.741C173.136 730.745 165.145 732.077 161.15 738.736L134.513 778.69C130.518 785.35 131.849 793.341 138.509 797.336C141.173 798.667 143.835 800 146.499 800C150.495 800 154.49 797.336 157.154 793.341L183.791 753.387C187.786 746.727 186.454 738.736 179.796 734.741Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M346.267 67.5053C354.258 67.5053 359.584 62.1786 359.584 54.1878V14.2336C359.584 6.24272 354.258 0.916016 346.267 0.916016C338.276 0.916016 332.949 6.24272 332.949 14.2336V54.1878C332.949 62.1786 338.276 67.5053 346.267 67.5053Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M346.267 733.409C338.276 733.409 332.949 738.736 332.949 746.727V786.681C332.949 794.672 338.276 799.998 346.267 799.998C354.258 799.998 359.584 794.672 359.584 786.681V746.727C359.586 738.736 354.258 733.409 346.267 733.409Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M13.3175 333.868H53.2717C61.2626 333.868 66.5893 328.541 66.5893 320.55C66.5893 312.559 61.2626 307.232 53.2717 307.232H13.3175C5.32671 307.232 0 312.559 0 320.55C0 328.541 5.32671 333.868 13.3175 333.868Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M53.2717 507.001C61.2626 507.001 66.5893 501.675 66.5893 493.684C66.5893 485.693 61.2626 480.366 53.2717 480.366H13.3175C5.32671 480.366 0 485.693 0 493.684C0 501.675 5.32671 507.001 13.3175 507.001H53.2717Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M639.267 307.23C631.276 307.23 625.949 312.557 625.949 320.548C625.949 328.539 631.276 333.866 639.267 333.866H679.221C687.212 333.866 692.539 328.539 692.539 320.548C692.539 312.557 687.212 307.23 679.221 307.23H639.267Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M679.221 480.366H639.267C631.276 480.366 625.949 485.693 625.949 493.684C625.949 501.675 631.276 507.001 639.267 507.001H679.221C687.212 507.001 692.539 501.675 692.539 493.684C692.539 485.693 687.212 480.366 679.221 480.366Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M584.662 592.744V202.019C585.388 199.843 585.302 197.674 584.662 195.714V195.359L584.454 195.117C583.9 193.713 583.062 192.428 581.998 191.364L502.089 98.138C501.531 97.5793 500.903 97.0939 500.24 96.6522L498.094 94.1426H193.111L106.543 195.359V605.556L107.954 607.206C108.291 607.988 108.686 608.77 109.207 609.552L189.115 702.778C189.674 703.336 190.302 703.822 190.965 704.263L193.111 706.773H499.427L517.692 684.798L583.331 608.22C585.995 605.556 587.326 601.561 585.995 597.565C585.993 595.888 585.502 594.224 584.662 592.744ZM197.106 576.257L235.729 614.88L198.439 670.816L141.172 604.225L197.106 576.257ZM258.369 600.23L213.088 554.949V247.301L259.702 200.688H434.169L456.81 223.329L479.451 245.97V554.949L434.17 600.23H258.369ZM495.432 576.257L551.367 604.225L494.1 670.816L456.81 614.88L495.432 576.257ZM495.432 224.66L456.809 186.037L494.099 130.101L551.366 196.692L495.432 224.66ZM432.393 174.051H261.476L225.961 120.779H467.905L432.393 174.051ZM198.438 130.101L235.728 186.037L197.105 224.66L141.183 196.7L169.802 163.398L198.438 130.101ZM133.18 221.996L186.451 248.633V551.618L133.18 578.255V221.996ZM260.145 626.865H432.393L467.908 680.136H224.631L260.145 626.865ZM506.085 551.618V247.3L560.689 219.998V578.92L506.085 551.618Z"
                      fill="#7C8689"
                    />
                    <path
                      d="M438.165 441.744C438.165 399.126 392.884 376.486 391.551 376.486C379.565 368.495 372.906 360.504 371.574 349.849C367.579 327.208 387.556 299.24 395.547 289.918C399.542 285.923 400.873 279.263 396.878 273.936C392.883 268.61 386.223 265.945 380.896 268.61C375.57 269.941 253.043 319.219 253.043 440.413C253.043 492.353 294.328 533.639 346.269 533.639C398.211 533.639 439.498 492.353 438.165 441.744ZM346.27 507.002C308.98 507.002 279.68 477.703 279.68 440.411C279.68 379.149 318.303 339.194 350.266 316.553C346.27 327.208 343.606 340.526 346.27 353.843C350.266 372.489 360.921 387.138 380.898 399.124C380.898 399.124 412.861 415.106 412.861 440.41C412.861 477.703 383.562 507.002 346.27 507.002Z"
                      fill="#7C8689"
                    />
                  </svg>
                )
              }
              color="primary"
            >
              {isMobile ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 693 800"
                  fill="none"
                  className="btn-svg"
                >
                  <path
                    d="M162.479 62.1786C165.143 64.8427 169.139 67.5053 173.134 67.5053C175.798 67.5053 178.461 66.174 179.793 66.174C186.453 62.1786 187.784 54.1878 183.789 47.5282L157.152 7.57403C153.157 0.914482 145.166 -0.416804 138.506 3.57862C133.18 7.57403 131.847 15.5649 135.842 22.2244L162.479 62.1786Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M625.948 174.05C629.943 174.05 632.607 172.719 635.27 170.055L675.224 130.101C680.551 124.774 680.551 116.783 675.224 111.455C669.897 106.128 661.906 106.128 656.578 111.455L616.624 151.409C611.297 156.736 611.297 164.727 616.624 170.055C619.29 172.719 621.952 174.05 625.948 174.05Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M49.2781 111.455C43.9514 106.128 35.9606 106.128 30.6323 111.455C25.3041 116.782 25.3056 124.773 30.6323 130.101L70.5865 170.055C73.2507 172.719 75.9132 174.05 79.9086 174.05C83.9041 174.05 86.5682 172.719 89.2308 170.055C94.5575 164.728 94.5575 156.737 89.2308 151.409L49.2781 111.455Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M511.415 64.843C514.079 66.1743 516.742 67.5071 519.406 67.5071C523.401 67.5071 527.397 64.843 530.061 60.8476L556.698 20.8934C560.692 14.2338 559.36 6.24298 552.701 2.24756C546.041 -1.74786 538.05 -0.416573 534.055 6.24298L507.418 46.1972C503.424 52.8567 504.756 60.8476 511.415 64.843Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M531.389 740.069C527.393 733.41 519.403 732.078 512.743 736.074C506.083 740.069 504.752 748.06 508.748 754.72L535.384 794.674C538.048 797.338 542.044 800 546.039 800C548.703 800 551.366 798.669 554.03 798.669C560.69 794.674 562.021 786.683 558.025 780.023L531.389 740.069Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M57.2656 630.859L17.3114 670.813C11.9847 676.14 11.9847 684.131 17.3114 689.459C19.9756 692.123 22.6381 693.455 26.6336 693.455C30.629 693.455 33.2931 692.123 35.9557 689.459L75.9099 649.505C81.2366 644.178 81.2366 636.188 75.9099 630.859C70.5832 625.533 62.5923 625.533 57.2656 630.859Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M621.953 630.859C616.627 625.533 608.636 625.533 603.308 630.859C597.981 636.186 597.981 644.177 603.308 649.505L643.262 689.459C645.926 692.123 648.588 693.455 652.584 693.455C656.579 693.455 659.243 692.123 661.906 689.459C667.233 684.133 667.233 676.142 661.906 670.813L621.953 630.859Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M179.796 734.741C173.136 730.745 165.145 732.077 161.15 738.736L134.513 778.69C130.518 785.35 131.849 793.341 138.509 797.336C141.173 798.667 143.835 800 146.499 800C150.495 800 154.49 797.336 157.154 793.341L183.791 753.387C187.786 746.727 186.454 738.736 179.796 734.741Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M346.267 67.5053C354.258 67.5053 359.584 62.1786 359.584 54.1878V14.2336C359.584 6.24272 354.258 0.916016 346.267 0.916016C338.276 0.916016 332.949 6.24272 332.949 14.2336V54.1878C332.949 62.1786 338.276 67.5053 346.267 67.5053Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M346.267 733.409C338.276 733.409 332.949 738.736 332.949 746.727V786.681C332.949 794.672 338.276 799.998 346.267 799.998C354.258 799.998 359.584 794.672 359.584 786.681V746.727C359.586 738.736 354.258 733.409 346.267 733.409Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M13.3175 333.868H53.2717C61.2626 333.868 66.5893 328.541 66.5893 320.55C66.5893 312.559 61.2626 307.232 53.2717 307.232H13.3175C5.32671 307.232 0 312.559 0 320.55C0 328.541 5.32671 333.868 13.3175 333.868Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M53.2717 507.001C61.2626 507.001 66.5893 501.675 66.5893 493.684C66.5893 485.693 61.2626 480.366 53.2717 480.366H13.3175C5.32671 480.366 0 485.693 0 493.684C0 501.675 5.32671 507.001 13.3175 507.001H53.2717Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M639.267 307.23C631.276 307.23 625.949 312.557 625.949 320.548C625.949 328.539 631.276 333.866 639.267 333.866H679.221C687.212 333.866 692.539 328.539 692.539 320.548C692.539 312.557 687.212 307.23 679.221 307.23H639.267Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M679.221 480.366H639.267C631.276 480.366 625.949 485.693 625.949 493.684C625.949 501.675 631.276 507.001 639.267 507.001H679.221C687.212 507.001 692.539 501.675 692.539 493.684C692.539 485.693 687.212 480.366 679.221 480.366Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M584.662 592.744V202.019C585.388 199.843 585.302 197.674 584.662 195.714V195.359L584.454 195.117C583.9 193.713 583.062 192.428 581.998 191.364L502.089 98.138C501.531 97.5793 500.903 97.0939 500.24 96.6522L498.094 94.1426H193.111L106.543 195.359V605.556L107.954 607.206C108.291 607.988 108.686 608.77 109.207 609.552L189.115 702.778C189.674 703.336 190.302 703.822 190.965 704.263L193.111 706.773H499.427L517.692 684.798L583.331 608.22C585.995 605.556 587.326 601.561 585.995 597.565C585.993 595.888 585.502 594.224 584.662 592.744ZM197.106 576.257L235.729 614.88L198.439 670.816L141.172 604.225L197.106 576.257ZM258.369 600.23L213.088 554.949V247.301L259.702 200.688H434.169L456.81 223.329L479.451 245.97V554.949L434.17 600.23H258.369ZM495.432 576.257L551.367 604.225L494.1 670.816L456.81 614.88L495.432 576.257ZM495.432 224.66L456.809 186.037L494.099 130.101L551.366 196.692L495.432 224.66ZM432.393 174.051H261.476L225.961 120.779H467.905L432.393 174.051ZM198.438 130.101L235.728 186.037L197.105 224.66L141.183 196.7L169.802 163.398L198.438 130.101ZM133.18 221.996L186.451 248.633V551.618L133.18 578.255V221.996ZM260.145 626.865H432.393L467.908 680.136H224.631L260.145 626.865ZM506.085 551.618V247.3L560.689 219.998V578.92L506.085 551.618Z"
                    fill="#7C8689"
                  />
                  <path
                    d="M438.165 441.744C438.165 399.126 392.884 376.486 391.551 376.486C379.565 368.495 372.906 360.504 371.574 349.849C367.579 327.208 387.556 299.24 395.547 289.918C399.542 285.923 400.873 279.263 396.878 273.936C392.883 268.61 386.223 265.945 380.896 268.61C375.57 269.941 253.043 319.219 253.043 440.413C253.043 492.353 294.328 533.639 346.269 533.639C398.211 533.639 439.498 492.353 438.165 441.744ZM346.27 507.002C308.98 507.002 279.68 477.703 279.68 440.411C279.68 379.149 318.303 339.194 350.266 316.553C346.27 327.208 343.606 340.526 346.27 353.843C350.266 372.489 360.921 387.138 380.898 399.124C380.898 399.124 412.861 415.106 412.861 440.41C412.861 477.703 383.562 507.002 346.27 507.002Z"
                    fill="#7C8689"
                  />
                </svg>
              ) : (
                "Jewelry"
              )}
            </LoadingButton>
            {Array.isArray(userParty) && (
              <FormControl
                sx={{
                  m: 1,
                  maxWidth: "350px",
                  width: "100%",
                  justifyContent: "end",
                  mb: "10px",
                  ml: 0,
                }}
                fullWidth
                size="small"
              >
                <InputLabel id="demo-select-small">Party</InputLabel>
                <Select
                  labelId="demo-select-small"
                  defaultValue={""}
                  label="Party"
                  onChange={(event) => setUserSelectedParty(event.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {userParty?.map((party) => (
                    <MenuItem
                      key={party.FL_PARTY_CODE}
                      value={party.FL_PARTY_CODE}
                    >
                      {party.FL_PARTY_NAME}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Stack>
        </Grid>
        <Grid item lg={5}>
          <Grid
            container
            sx={{ gap: "14px", justifyContent: "end", alignItems: "baseline" }}
          >
            {inventoryType != "jewel" && (
              <BasketExcelGenerate
                data={SelectedStoneBasketData}
                text={"Client Excel"}
                sx={{ display: "flex", margin: "0 0px 22px 0" }}
              />
            )}
            <LoadingButton
              variant="contained"
              onClick={() => setOpetMemoDialoge(true)}
              disabled={!SelectedStone?.length > 0}
              sx={{ display: "flex", margin: "0 0px 22px 0" }}
              startIcon={
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 750 750"
                  fill="none"
                  className="btn-svg"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M375 0C167.9 0 0 167.9 0 375C0 582.1 167.9 750 375 750C582.1 750 750 582.1 750 375C750 167.9 582.1 0 375 0ZM375 25C567.988 25 725 182.012 725 375H25C25 182.012 182.012 25 375 25Z"
                    fill="#7C8689"
                  />
                </svg>
              }
              color="primary"
            >
              Memo
            </LoadingButton>
            <LoadingButton
              variant="contained"
              onClick={() => setOpetSoldDialoge(true)}
              disabled={!SelectedStone?.length > 0}
              sx={{ display: "flex", margin: "0 0px 22px 0" }}
              startIcon={<DataThresholdingOutlinedIcon />}
              color="primary"
            >
              Sold
            </LoadingButton>
            {isMobile ? (
              <Tooltip title="Remove From Basket">
                <Fab
                  variant="contained"
                  size="small"
                  loading={BLOADER}
                  disabled={!SelectedStone?.length > 0}
                  onClick={ReomvetoBasketHandler}
                  sx={{ display: "flex", margin: "0 0px 22px 0" }}
                  color="primary"
                >
                  <RemoveShoppingCartOutlinedIcon />
                </Fab>
              </Tooltip>
            ) : (
              <LoadingButton
                variant="contained"
                loading={BLOADER}
                disabled={!SelectedStone?.length > 0}
                onClick={ReomvetoBasketHandler}
                sx={{ display: "flex", margin: "0 0px 22px 0" }}
                startIcon={<RemoveShoppingCartOutlinedIcon />}
                color="primary"
              >
                Remove
              </LoadingButton>
            )}
          </Grid>
        </Grid>
      </Grid>

      {userSelectedParty &&
        (inventoryType == "single" ? (
          <StoneTableViewWIthBasket
            SelectedStoneBasketData={SelectedStoneBasketData}
            setSelectedStoneBasketData={setSelectedStoneBasketData}
            Stoneresultdata={basketData}
            SelectedStone={SelectedStone}
            setStoneresultdata={setBasketData}
            setSelectedStone={setSelectedStone}
          />
        ) : inventoryType == "jewel" ? (
          <JewelryTableWithBasket
            SelectedStoneBasketData={SelectedStoneBasketData}
            setSelectedStoneBasketData={setSelectedStoneBasketData}
            Stoneresultdata={basketData}
            SelectedStone={SelectedStone}
            setStoneresultdata={setBasketData}
            setSelectedStone={setSelectedStone}
          />
        ) : (
          <StoneTableWithBasket
            SelectedStoneBasketData={SelectedStoneBasketData}
            setSelectedStoneBasketData={setSelectedStoneBasketData}
            Stoneresultdata={basketData}
            SelectedStone={SelectedStone}
            setStoneresultdata={setBasketData}
            setSelectedStone={setSelectedStone}
          />
        ))}
      {userSelectedParty && basketData && (
        <>
          {" "}
          <ShippingFormMemoDialog
            open={opetMemoDialoge}
            userSelectedParty={userSelectedParty}
            basketData={basketData}
            SelectedStone={SelectedStone}
            handleClose={() => {
              setOpetMemoDialoge(!opetMemoDialoge);
              fetchBasketdata();
            }}
          />
          {inventoryType == "single" ? (
            <ShippingFormSoldDialog
              open={opetSoldDialoge}
              userSelectedParty={userSelectedParty}
              SelectedStone={SelectedStone}
              handleClose={() => setOpetSoldDialoge(!opetSoldDialoge)}
            />
          ) : inventoryType == "jewel" ? (
            <JewelryShippingFormSoldDialog
              open={opetSoldDialoge}
              userSelectedParty={userSelectedParty}
              SelectedStone={SelectedStone}
              handleClose={() => setOpetSoldDialoge(!opetSoldDialoge)}
            />
          ) : (
            <BulkShippingFormSoldDialog
              open={opetSoldDialoge}
              userSelectedParty={userSelectedParty}
              SelectedStone={SelectedStone}
              handleClose={() => setOpetSoldDialoge(!opetSoldDialoge)}
            />
          )}
        </>
      )}
    </div>
  );
}

MyBasket.Modulename = "AdminBasket";
